import {Component, DestroyRef, EventEmitter, inject, OnInit, Output, ChangeDetectionStrategy} from "@angular/core";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef,} from "@angular/material/bottom-sheet";
import {LorenBottomSheetDataConfig, LorenBottomSheetItem,} from "../../interfaces/loren-bottom-sheet-config.interface";
import {
    LorenBreakpointObserverService
} from "../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: "loren-bottom-sheet",
    templateUrl: "./loren-bottom-sheet.component.html",
    styleUrls: ["./loren-bottom-sheet.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenBottomSheetComponent implements OnInit {
    private bottomSheet = inject<MatBottomSheetRef<LorenBottomSheetComponent>>(MatBottomSheetRef);
    private breakpointObserverService = inject(LorenBreakpointObserverService);
    bottomSheetData = inject<LorenBottomSheetDataConfig>(MAT_BOTTOM_SHEET_DATA);
    private readonly destroyRef = inject(DestroyRef);

    @Output() itemClick = new EventEmitter<LorenBottomSheetItem>();
    isHandset: boolean;

    handleClick(item: LorenBottomSheetItem, event): void {
        this.closeBottomSheet();
        this.itemClick.emit(item);
        event.preventDefault();
    }

    ngOnInit(): void {
        this.breakpointObserverService
            .getHandsetStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((x) => (this.isHandset = x));
    }

    closeBottomSheet() {
        this.bottomSheet.dismiss();
    }
}
